import { User } from 'types/graphql'

export const abbreviateFullName = (user: User): string => {
  if (!user?.firstName || !user?.lastName) {
    return ''
  }

  return `${user?.firstName} ${user?.lastName?.[0]}.`
}
